import type { TimelineEvent } from "@/mocks/articles";

interface ArticleTimelineProps {
  events: TimelineEvent[];
}

export default function ArticleTimeline({ events }: ArticleTimelineProps) {
  return (
    <section id="timeline" className="scroll-mt-28">
      <h2 className="flex items-center gap-3 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        <i className="ri-timeline-view text-accent-500" />
        完整时间线
      </h2>
      <p className="mt-3 text-sm leading-relaxed text-foreground-600">
        以下节点按公开信息出现的时间排序，帮助还原事件发生的先后顺序。
      </p>

      <ol className="relative mt-7 space-y-7 border-l border-background-300/60 pl-7">
        {events.map((node, index) => (
          <li key={`${node.date}-${index}`} className="relative">
            <span className="absolute -left-[35px] top-1 flex h-5 w-5 items-center justify-center rounded-full bg-background-100 ring-1 ring-accent-700/60">
              <span className="h-2 w-2 rounded-full bg-accent-500" />
            </span>
            <div className="rounded-lg border border-background-200/70 bg-background-100 p-4 md:p-5">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <span className="rounded-full bg-primary-950 px-3 py-1 font-heading text-xs text-accent-400">
                  {node.date}
                </span>
                <span className="text-[11px] text-foreground-500">
                  节点 {String(index + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">
                {node.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{node.desc}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}